import { blockWidthAlignMargins } from "../block-width";
import {
  resolveLinkColor,
  resolveTextColor,
  resolveTextFontFamily,
  type TextTheme,
} from "../text-theme";
import type { TextBlock } from "../types";
import type { CSSProperties } from 'react';

export function textBlockTypographyStyle(
  block: TextBlock,
  textTheme: TextTheme,
  extra?: CSSProperties,
): CSSProperties {
  return {
    textAlign: block.align,
    color: resolveTextColor(block, textTheme),
    fontSize: block.fontSize,
    fontWeight: block.fontWeight,
    lineHeight: block.lineHeight,
    fontFamily: resolveTextFontFamily(block, textTheme),
    letterSpacing: 'normal',
    wordBreak: 'break-word',
    ['--text-block-link-color' as string]: resolveLinkColor(block, textTheme),
    ...extra,
  };
}

export function textBlockShellTableStyle(
  block: TextBlock,
  widthPx: number,
): CSSProperties {
  return {
    width: '100%',
    maxWidth: widthPx,
    ...blockWidthAlignMargins(block.align),
  };
}
